import React from 'react'
import {
  List, Datagrid, TextField, BooleanField, ReferenceField, DateField, SelectField, Filter, ReferenceInput, SelectInput
} from 'admin-on-rest'
import MonetaryField from '../components/monetaryField'
import IDField from '../components/idField'

const zero = <span> 0 </span>
const OdometerField = ({ record = {} }) =>
  <span>
    {isNaN(record.odometer) ? zero : record.odometer} km
  </span>
OdometerField.defaultProps = { label: 'Odômetro' }

const TransactionFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label='Empresa' source='_organization' reference='organization' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
    <ReferenceInput label='Posto' source='_gasStation' reference='gasStation' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
  </Filter>
)

export const TransactionList = (props) => (
  <List {...props} title='Transações' filters={<TransactionFilter />}>
    <Datagrid>
      <IDField label='ID' source='_id' />
      <DateField label='Data' source='createdAt' locales='pt-br' showTime />
      <ReferenceField source='_user' reference='user' label='Usuário'>
        <TextField label='Nome' source='firstName' />
      </ReferenceField>
      <ReferenceField source='_vehicle' reference='vehicle' label='Veículo' allowEmpty>
        <TextField label='Veículo' source='licensePlate' />
      </ReferenceField>
      <ReferenceField source='_gasStation' reference='gasStation' label='Posto'>
        <TextField label='Nome' source='name' />
      </ReferenceField>
      <OdometerField label='Odômetro' source='odometer' />
      <SelectField label='Combustível' source='fuelType' choices={[
        {id: 'ethanol', name: 'Etanol'},
        {id: 'premiumEthanol', name: 'Etanol Aditivado'},
        {id: 'gas', name: 'Gasolina'},
        {id: 'diesel', name: 'Diesel S10'},
        {id: 'dieselS500', name: 'Diesel S500'},
        {id: 'premiumGas', name: 'Gasolina Aditivada'},
        {id: 'arla', name: 'Arla'},
        {id: 'carrierNaturalGas', name: 'Gás Natural Veicular'}
      ]}
      />
      <MonetaryField label='Preço' source='fuelCost' />
      <MonetaryField label='Total' source='value' />
      <BooleanField label='Sucesso' source='successful' />
    </Datagrid>
  </List>
)



// WEBPACK FOOTER //
// ./src/collections/transactions.js